module.exports = __webpack_public_path__ + "static/media/MajooCRM6.64cb14f5.png";